<template>
  <div id="herospark-banner-sidenav">
    <Content :id="active.id" :currentView="currentView" />
  </div>
</template>

<script>
import Content from './herospark-banner/Content'
import Mixin from './Mixin.js'

export default {
  name: 'HeroSparkBannerSideNav',
  mixins: [Mixin],
  components: { Content },
}
</script>

<style></style>
